import React from 'react';
import Carousel from 'react-material-ui-carousel'

import Item from './item'


const SlideShow = ({ photos }) => {
    
    return (
        <Carousel autoPlay={false}>
            {
                photos.map((photo, index) => <Item key={index} photo={photo} /> )
            }
        </Carousel>
    )

}; 

export default SlideShow;
